<template>
    <div>
        <v-card class="pa-2" color="#42A5F5">
            <canvas id="chart4" ref="chart4" height="500"></canvas>
        </v-card>
    </div>
</template>

<script>
import Chart from 'chart.js';
import moment from 'moment';

export default {
    data() {
        return {
            chart: null,
            canvas: null,
            loading: true,
            labels: [],
            amountCurr: [],
            amountPast: [],
            amountFut: []
        }
    },
    watch: {
        chartData() {
            this.render();
        }
    },
    props: {
        chartData: Array
    },
    mounted() {
        this.render();
    },
    methods: {
        render() {
            if(this.chart && this.canvas) {
                this.chart.destroy();
                this.canvas = null;
            }
            
            this.labels = this.chartData.map(e => e.current);
            this.amountCurr = this.chartData.map(e => e.amountCurr);
            this.amountPast = this.chartData.map(e => e.amountPast);
            this.amountFut = this.chartData.map(e => e.amountFut);

            this.canvas = this.$refs['chart4'].getContext('2d');
            let chartData = { datasets: [] };
            chartData.datasets.push({ label: 'Current',
                                      data: this.amountCurr,
                                      borderColor: '#FFF',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(255, 255, 255, 0)",
                                      pointBackgroundColor: "rgb(255, 255, 255)",
                                      pointHoverBackgroundColor: "rgb(255, 255, 255)",
                                      pointRadius: 2,
                                      pointHoverRadius: 4 });

            chartData.datasets.push({ label: 'Past',
                                      data: this.amountPast,
                                      borderColor: '#E57373',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(255, 255, 255, 0)",
                                      pointBackgroundColor: "#E57373",
                                      pointHoverBackgroundColor: "#E57373",
                                      pointRadius: 2,
                                      pointHoverRadius: 4 });

            chartData.datasets.push({ label: 'Future',
                                      data: this.amountFut,
                                      borderColor: '#0D47A1',
                                      borderWidth: 1,
                                      backgroundColor: "rgb(255, 255, 255, 0)",
                                      pointBackgroundColor: "#0D47A1",
                                      pointHoverBackgroundColor: "#0D47A1",
                                      pointRadius: 2,
                                      pointHoverRadius: 4 });

            this.chart = new Chart(this.canvas, {
                type: 'line',
                data: {
                    labels: this.labels,
                    datasets: chartData.datasets,
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    title: {
                        display: true,
                        text: '',
                        fontSize: 12,
                        fontStyle: 400,
                        fontColor: '#FFF'
                    },
                    scales: {
                        yAxes: [{
                            positions: 'left',
                            ticks: {
                                id: 1,
                                minTicksLimit: 10,
                                beginAtZero: true,
                                fontSize: 10,
                                fontColor: '#FFF',
                                callback: function(value) {
                                    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP', minimumFractionDigits: 0 }).format(value);
                                }
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Value',
                                fontSize: 12,
                                fontColor: '#FFF'
                            },
                            gridLines: {
                                zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 0.2)"
                            }
                        }],
                        xAxes: [{
                            ticks: {
                                beginAtZero: true,
                                fontSize: 10,
                                fontColor: '#FFF'
                            },
                            scaleLabel: {
                                display: true,
                                labelString: '',
                                fontSize: 12,
                                fontColor: '#FFF'
                            },
                            gridLines: {
                                zeroLineColor: "rgb(255, 255, 255, 0.2)",
                                color: "rgb(255, 255, 255, 0.2)"
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        labels: {
                            fontSize: 10,
                            fontColor: '#FFF',
                            usePointStyle: true
                        },
                        position: 'top'
                    },
                    tooltips: {
                        mode: 'label',
                        callbacks: {
                            title: function(tooltipItems, data) {
                                return '';
                            },
                            label: function(tooltipItem, data) {
                                let label = '';

                                if(data.datasets[tooltipItem.datasetIndex].label == 'Past') {
                                    label += moment(data.labels[tooltipItem.index]).subtract(1, 'month').format('YYYY-MM-DD') + ': £' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                }
                                else if(data.datasets[tooltipItem.datasetIndex].label == 'Current') {
                                    label += data.labels[tooltipItem.index] + ': £' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                }
                                else if(data.datasets[tooltipItem.datasetIndex].label == 'Future') {
                                    label += moment(data.labels[tooltipItem.index]).add(1, 'month').format('YYYY-MM-DD') + ': £' + + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                                }

                                return label;
                            }
                        }
                    }
                }
            })
        }
    }
}
</script>

<style>

</style>